import slideToggle from './slideToggle';

document.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('.accordion-block')) {
		const accordionItems = document.querySelectorAll(
			'.accordion-block__item'
		);

		accordionItems.forEach((accordionItem) => {
			const accordionToggle = accordionItem.querySelector(
				'.accordion-block__label'
			);

			const accordionContent = accordionItem.querySelector(
				'.accordion-block__content'
			);

			accordionToggle.addEventListener('click', () => {
				slideToggle(accordionContent);

				if (accordionToggle.classList.contains('open')) {
					accordionToggle.classList.remove('open');
					accordionToggle.setAttribute('aria-expanded', false);
				} else {
					accordionToggle.classList.add('open');
					accordionToggle.setAttribute('aria-expanded', true);
				}
			});
		}); // end accordion items
	} // end if
});
